import React, { lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AssetDetails from "./components/assetDetails/assetDetails.tsx";
import CustomerDetails from "./components/customerDetails/customerDetails.tsx";
import { Layout } from "./layout/pageLayout.tsx";
import { IndexPage } from "./layout/indexPage.tsx";
import UserDetails from "./components/userDetails/userDetails.tsx";
import { setFavicon } from "./utilities/setFavicon.tsx";
import useConfig from "./hooks/useConfig.ts";

const Login = lazy(() => import('./features/common/login/Login.tsx'));
const AuthComponent = lazy(() => import('./features/common/AuthComponent.tsx'));

const App: React.FC = () => {

  const { appPath } = useConfig();

  const applyTheme = () => {
    setFavicon();
  };

  applyTheme();

  return (
    <Router>
      <Routes>
      <Route path={appPath + "/login"} element={<Login />} />
      <Route path={appPath} element={<AuthComponent component={Layout} />}>
        <Route index element={<IndexPage />} />
        <Route path={appPath + "/asset-details"} element={<AssetDetails />} />
        <Route path={appPath + "/user-details"} element={<UserDetails />} />
        <Route path={appPath + "/customer-details"} element={<CustomerDetails />} />
        
      </Route>
      </Routes>
    </Router>
  );
};

export default App;
